// Imports
import styled from 'styled-components';

// Main Component
const CatalogFooterStyles = styled.div``;

// Export
export default CatalogFooterStyles;
